import React from "react";
import { ReactComponent as Logo } from "../../assets/images/logo.svg"
import { Container } from "./styles";

export function Header() {
  return (
    <Container>
      <Logo width={148}/>
    </Container>
  )
}